module.exports = __webpack_public_path__ + "img/ug411.be3d943c.png";